"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAttribute = exports.getAttributesFromDna = exports.getAttributesMap = exports.CoinPickAxeAttributes = exports.pickAxeAttributes = void 0;
const enum_1 = require("./utils/enum");
const types_1 = require("./types");
exports.pickAxeAttributes = [
    { trait_type: "Tier", values: types_1.CoinPickAxeTier },
    { trait_type: "Base Color", values: types_1.CoinPickAxeValues.BaseColor },
    { trait_type: "Base Style", values: types_1.CoinPickAxeValues.BaseStyle },
    { trait_type: "Base Top Style", values: types_1.CoinPickAxeValues.BaseTopStyle },
    { trait_type: "Blade Style", values: types_1.CoinPickAxeValues.BladeStyle },
    { trait_type: "Blade Detail", values: types_1.CoinPickAxeValues.BladeDetail },
    { trait_type: "Gem Color", values: types_1.CoinPickAxeValues.GemColor },
    { trait_type: "Gem Shape", values: types_1.CoinPickAxeValues.GemShape },
    { trait_type: "Handle Material", values: types_1.CoinPickAxeValues.HandleMaterial },
    { trait_type: "Base Flair Shape", values: types_1.CoinPickAxeValues.BaseFlairShape },
    { trait_type: "Base Flair Color", values: types_1.CoinPickAxeValues.BaseFlairColor },
    { trait_type: "Ring Shape", values: types_1.CoinPickAxeValues.RingShape },
    { trait_type: "Ring Color", values: types_1.CoinPickAxeValues.RingColor },
];
class CoinPickAxeAttributes {
}
exports.CoinPickAxeAttributes = CoinPickAxeAttributes;
_a = CoinPickAxeAttributes;
CoinPickAxeAttributes.initial = (0, enum_1.enumValues)(types_1.CoinPickAxeTier).reduce((acc, tier) => (Object.assign(Object.assign({}, acc), { [tier]: [tier, ...exports.pickAxeAttributes.slice(1).map(() => 0)] })), {});
CoinPickAxeAttributes.indexOf = (values) => {
    return exports.pickAxeAttributes.findIndex((attr) => attr.values === values);
};
CoinPickAxeAttributes.attrNumFn = (values) => {
    const idx = _a.indexOf(values);
    return (dna) => {
        return Number(dna[idx]);
    };
};
CoinPickAxeAttributes.attrFn = (values) => {
    const idx = _a.indexOf(values);
    return (dna) => {
        const tier = types_1.CoinPickAxeTier[dna[0]];
        return values[tier][dna[idx]];
    };
};
CoinPickAxeAttributes.attrNumFns = (values) => {
    return values.map((attr) => _a.attrNumFn(attr));
};
CoinPickAxeAttributes.attrFns = (values) => {
    return values.map((attr) => _a.attrFn(attr));
};
CoinPickAxeAttributes.randomTierFns = Object.keys(types_1.CoinPickAxeTier).reduce((acc, tier) => {
    const value = exports.pickAxeAttributes.slice(1).map((attr) => (0, enum_1.makeSelectRandomEnum)(attr.values[tier] || attr.values[types_1.CoinPickAxeTier[tier]]));
    acc[tier] = value;
    return acc;
}, {});
CoinPickAxeAttributes.randomTier = (0, enum_1.makeSelectRandomEnum)(types_1.CoinPickAxeTier);
CoinPickAxeAttributes.random = (tier) => {
    const attrs = _a.randomTierFns[tier].map((fn) => fn());
    return [tier, ...attrs].join('');
};
function getAttributesMap() {
    return exports.pickAxeAttributes.map(({ trait_type, values }) => {
        if (values === types_1.CoinPickAxeTier) {
            return {
                trait_type,
                values: (0, enum_1.enumValues)(values).map(v => values[v])
            };
        }
        const vals = Object.keys(values).reduce((acc, key) => {
            acc[types_1.CoinPickAxeTier[key] - 1] = (0, enum_1.enumValues)(values[key]).map(k => values[key][k]);
            return acc;
        }, []);
        return {
            trait_type,
            values: vals
        };
    });
}
exports.getAttributesMap = getAttributesMap;
function getAttributesFromDna(dna) {
    if (dna.length !== exports.pickAxeAttributes.length) {
        throw new Error('Invalid attribute length');
    }
    return exports.pickAxeAttributes.reduce((attrs, { trait_type, values }, i) => {
        const tier = types_1.CoinPickAxeTier[dna[0]];
        if (values === types_1.CoinPickAxeTier) {
            if (!tier) {
                throw new Error(`Invalid tier ${dna[0]}`);
            }
            return attrs.concat({ trait_type, value: tier });
        }
        const value = values[tier][dna[i]];
        if (!value) {
            throw new Error(`No valid attribute found for ${tier} ${trait_type} ${dna} ${dna[i]}`);
        }
        return attrs.concat({ trait_type, value });
    }, []);
}
exports.getAttributesFromDna = getAttributesFromDna;
function verifyAttribute(values) {
    const idx = CoinPickAxeAttributes.indexOf(values);
    const { trait_type } = exports.pickAxeAttributes[idx];
    return (tier, value) => {
        const attr = values[tier]; //as unknown as V[keyof V]
        const next = attr[value];
        if (typeof next === "undefined") {
            throw new Error(`${String(value)} is not a valid attribute for ${tier} ${trait_type} - (e.g. ${(0, enum_1.enumKeys)(attr).join(", ")})`);
        }
        return next;
    };
}
exports.verifyAttribute = verifyAttribute;
//# sourceMappingURL=attributes.js.map